import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppHttpInterceptor } from './shared/services/http.interceptor';
import { ToasterService } from './shared/common-components/toaster/toaster.service';
import { EncryptionService } from './shared/services/encryption.service';
import { DateFormatterService } from './shared/services/date-formatter.service';
import { ToastInterceptor } from './shared/common-components/toaster/toast.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ToastInterceptor, multi: true },
    ToasterService,
    EncryptionService,
    DateFormatterService
  ]
};
